import React from 'react';

import importAll from 'helpers/importAll';

import FooterContainer from 'containers/footer/FooterContainer';
import { default as Navbar } from 'containers/navbar/NavbarContainer';

const images = importAll(require.context('assets/img/stock/mauritius', false, /\.(png|jpe?g|svg)$/));

export default () =>
    <div className="fullheight">
        <Navbar />

        <section className="intro">
            {/* <!-- Down Arrow --> */}
            <a href="#welcome" className="down_block go">
                <i className="fa fa-angle-down" />
            </a>

            {/* <!-- Wrapper --> */}
            <div className="intro_wrapper">
                {/* <!-- Item --> */}
                <div className="intro_item">
                    {/* <!-- Over --> */}
                    <div className="over" data-opacity="0.3" data-color="#292929" />
                    <div
                        className="into_back into_zoom image_bck"
                        data-image={images['beach_2.jpg']}
                    />
                    <div className="text_content">
                        <div className="intro_text intro_text_lc text-left text_up">
                            <span className="great_title great_title_big">
                                Mauritius
                            </span>
                            <span className="great_subtitle great_subtitle_big">
                                {/* some some  */}
                            </span>
                            <span className="into_txt">
                                As close as you will ever get to paradise
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Wrapper End --> */}
        </section>

        <div className="after_slider_border"></div>
        
        {/* <!-- Gallery--> */}
        <section className="boxes films" id="gallery">
            <div className="film_wrapper bg-black">
                {Object.keys(images).map(imageName => {
                    return <a key={imageName} href={images[imageName]} className="film_item image_bck lightbox" data-image={images[imageName]}></a> 
                })}
                
            </div>
        </section>
        {/* <!-- Gallery End--> */}
        <FooterContainer />
    </div>;



// WEBPACK FOOTER //
// ./src/pages/gallery/mauritius/MauritiusGallery.jsx